/* eslint-disable no-alert */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */

import React, { useState } from 'react';

import axios from 'axios';

import { useParams } from 'react-router-dom';

import {
  ButtonPurple,
  ButtonSend,
  ContainerImageInput,
  ContainerImages,
  ImageStrip,
  Input,
} from './style';

import sherwinWilliamsPNG from '../../assets/images/promos/sherwin-williams-strip.png';
import boticarioStripPNG from '../../assets/images/promos/boticario-strip.png';
import magaluStripPNG from '../../assets/images/promos/magalu-strip.png';
import olivaStripPNG from '../../assets/images/promos/oliva-strip.png';
import secondStripPNG from '../../assets/images/promos/second-strip.png';
import thirdStripPNG from '../../assets/images/promos/third-strip.png';
import thirdStripWhgPNG from '../../assets/images/promos/third-strip-whg.png';
import itauStripPNG from '../../assets/images/promos/itau-strip.png';
import marceloTostesPNG from '../../assets/images/promos/marcelo-tostes-strip.png';
import odaraStripPNG from '../../assets/images/promos/odara-strip.png';
import whgStripPNG from '../../assets/images/promos/whg-strip.png';

const USERS_BASE_URL = process.env.REACT_APP_USERS_BASE_URL;

const promoToShow = {
  oboticario: {
    strip: boticarioStripPNG,
    promo: 'Promoção Boticário',
    thirdStrip: thirdStripPNG,
  },
  magalu: {
    strip: magaluStripPNG,
    promo: 'Promoção Magalu 2',
    thirdStrip: thirdStripPNG,
  },
  oliva: {
    strip: olivaStripPNG,
    promo: 'Promoção Oliva',
    thirdStrip: thirdStripPNG,
  },
  itau: {
    strip: itauStripPNG,
    promo: 'Promoção Itaú',
    thirdStrip: thirdStripPNG,
  },
  sherwinWilliams: {
    strip: sherwinWilliamsPNG,
    promo: 'Promoção Sherwin Williams',
    thirdStrip: thirdStripPNG,
  },
  marceloTostes: {
    strip: marceloTostesPNG,
    promo: 'Promoção MarceloTostes',
    thirdStrip: thirdStripPNG,
  },
  odara: {
    strip: odaraStripPNG,
    promo: 'Promoção Odara',
    thirdStrip: thirdStripPNG,
  },
  whg: {
    strip: whgStripPNG,
    promo: 'Promoção WHG',
    thirdStrip: thirdStripWhgPNG,
  },
};

export default function Promo(): JSX.Element {
  const [email, setEmail] = useState('');

  const { type } = useParams<{ type: string }>();

  function redirectToStore(): void {
    const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera;

    const isAndroid: boolean = /android/i.test(userAgent);
    const isIOS: boolean = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isWindows: boolean = /Win/i.test(userAgent);
    const isMac: boolean = /Mac/i.test(userAgent);

    if (isAndroid || isWindows) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.guilu.appresolvaclub';
    } else if (isIOS || isMac) {
      window.location.href =
        'https://apps.apple.com/br/app/resolva-arm%C3%A1rio-digital/id1575252378';
    } else {
      alert(
        'Sistema operacional não identificado. Por favor, acesse a loja de aplicativos manualmente.'
      );
    }
  }

  const handleSend = async (event: React.FormEvent): Promise<void> => {
    event.preventDefault();

    console.log(email);

    try {
      await axios.post(`${USERS_BASE_URL}check-subscriptions/insert-username-for-promo`, {
        username: email,
        promo: promoToShow[type].promo,
      });

      alert('Tudo certo! Agora se cadastre no app com este mesmo email e aproveite os benefícios!');
    } catch (e) {
      if (e.response.data.sqlMessage.includes('Duplicate entry')) {
        alert('Email já registrado na promoção! Utilize outro email para prosseguir');
      } else {
        alert(
          `Ocorreu um erro ao registrar seu email. Por favor contate a central através do whatsapp: +55 (11) 93400-9574. ${e.response.data}`
        );
      }
    }
  };

  return (
    <ContainerImages>
      <form onSubmit={handleSend}>
        <ContainerImageInput style={{ position: 'relative' }}>
          <ImageStrip src={promoToShow[type].strip} />
          <Input
            placeholder="E-mail"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            type="email"
            required
          />
          <ButtonSend type="submit">Enviar</ButtonSend>
        </ContainerImageInput>
      </form>
      <ContainerImageInput style={{ position: 'relative' }}>
        <ImageStrip src={secondStripPNG} />
        <ButtonPurple bottom="750px" onClick={redirectToStore} right="auto">
          Clique aqui!
        </ButtonPurple>
      </ContainerImageInput>
      <ContainerImageInput style={{ position: 'relative' }}>
        <ImageStrip src={promoToShow[type].thirdStrip} />
        <ButtonPurple bottom="220px" onClick={redirectToStore}>
          Baixe agora!
        </ButtonPurple>
      </ContainerImageInput>
    </ContainerImages>
  );
}
